import { render, staticRenderFns } from "./AllClients.vue?vue&type=template&id=790ff3ee&scoped=true&"
import script from "./AllClients.vue?vue&type=script&lang=js&"
export * from "./AllClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ff3ee",
  null
  
)

export default component.exports